import React, { useContext, useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import { SidebarProps } from "react-sidebar";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IXeroEmailInvoiceDTO from "../../../models/DTO/IXeroEmailInvoiceDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OwButton from "../OwButton/OwButton";
import OwLabel from "../OwLabel/OwLabel";
import { Socket } from "socket.io-client";

type Props = {
    file: ArrayBuffer;
    toggleSidebar: (shouldBeVisible?: boolean, sidebarProps?: SidebarProps) => void;
    orderModel: IOrder;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const XeroInvoiceSidebar: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.XeroOnEmailInvoice, onEmailInvoice);
        props.socket.on(EndpointsEnum.Notify, notify);

        return () => {
            props.socket.removeListener(EndpointsEnum.XeroOnEmailInvoice, onEmailInvoice);
            props.socket.removeListener(EndpointsEnum.Notify, notify);
        };
    });

    const closeSidebar = () => {
        props.toggleSidebar(false);
    };

    const downloadPDF = () => {
        const blob = new Blob([props.file], { type: "application/pdf" }); // change resultByte to bytes

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        const fileName = props.orderModel.name;

        link.download = `${fileName} Invoice.pdf`;
        link.click();
    };

    const notify = () => {
        setIsActive(false);
    };

    const emailInvoice = () => {
        const payload: IXeroEmailInvoiceDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            orderGuid: props.orderModel.guid,
        };

        props.socket.emit(EndpointsEnum.XeroEmailInvoice, payload);

        setIsActive(true);
    };

    const onEmailInvoice = () => {
        const notification: INotification = {
            message: "SUCCESSFULLY_EMAILED_INVOICE",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        props.notifyFn(null, notification);

        setIsActive(false);
    };

    const collectPayment = () => {
        // V2
    };

    return (
        <div className={"XeroInvoiceSidebar"}>
            <div className={"text-end p-2"}>
                <OwButton centerIconClass={"fas fa-times"} className={"btn-danger"} fn={closeSidebar} />
            </div>
            <div className={"p-2"}>
                <OwButton leftIconClass={"fad fa-download"} title={"download_pdf"} fn={downloadPDF} />
                <OwButton
                    className={"ms-2 btn-primary"}
                    leftIconClass={"fad fa-envelope"}
                    title={"email_invoice"}
                    fn={emailInvoice}
                    disableOnActive={true}
                    active={isActive}
                />
                <div>
                    {props.orderModel.xero_invoice_emailed ? (
                        <OwLabel className={"text-success"} title={"invoice_emailed"} leftIconClass={"fas fa-check"} />
                    ) : null}
                </div>
            </div>
            <div style={{ height: "80%", overflow: "scroll" }}>
                <Document
                    // className="vh-90"
                    renderMode="canvas"
                    file={props.file}
                    // onLoadSuccess={this.onDocumentLoadSuccess}
                    // onLoadError={this.onDocumentLoadError}
                    // onSourceSuccess={this.onDocumentSourceSuccess}
                    // onSourceError={this.onDocumentSourceError}
                >
                    <Page pageIndex={0} />
                </Document>
            </div>
        </div>
    );
};
